import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import editManagePlayerInputs from './objects/edit_manage_player_inputs';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';


class ManagePlayersForAccount extends Component {
  constructor(props) {
    super(props);
    this.state={
        rerender: false,
        waitState: false,
        updateStep: "initial",
        updateType: "",
        headers: setHeadersForFetch(),
        environment: Config.dataURL.currentEnv,
    }    
   
    this.initialization();
    
}
//  The 'remove' option supported by this process could be problematic if ever decide to charge $ for the game.
//    Then would need to keep previous class code - or something similar to do billing correctly....  even then, 
//    should only charge $ if player has (or had) created a 'game'. 

initialization(){
    this.loginInfo = {accountNbr: "", role: ""};
    this.userFound = false;
    this.updateTypeClass = "";
    this.accountNbrClass = "";
    this.roleClass = "";
    this.accountNbr = "";
    this.newAccountNbrClass = "";
    this.message = "";
    this.messageClass = ""
    this.userName = "";
    this.roleMessage = "";
    this.newAccountNbr = "";
}

handleUpdateTypeChange(updateType){
    this.startOver();
    this.setState({updateType: updateType});
}

handleUsernameChange(userName){
    this.userName = userName;
    this.startOver();
}

handleAccountNbrChange(accountNbr){
    this.newAccountNbr = accountNbr;
    this.startOver();
}

render() {
    const firstChar = this.props.role.substring(0,1).toUpperCase();
    const upperCaseRole = firstChar + this.props.role.substring(1, this.props.role.length);
return <>
    <Modal className="text-center" show={this.props.show}  onHide={() => this.props.onClose()} 
       size="med" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Add/Change {upperCaseRole}s for {this.props.accountType} Code &nbsp;
                {this.props.userAccountInfo.accountNbr}
                {this.props.accountType === "Class"  ?
                    <>
                        <div>{this.props.userAccountInfo.className}</div> 
                    </>
                :
                    null
                }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
              {this.state.waitState   ?
                <WaitTimeSpinner  />
              :
                null
              }
              <span>
                <div className="mx-3 my-4 font-weight-normal text-left">
                    <label className={this.updateTypeClass} htmlFor="updateType">Type of Change?:&nbsp;&nbsp;
                    </label>             
                    <select value={this.state.updateType || "none"}
                    onChange={(val) => this.handleUpdateTypeChange(val.target.value)}
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="updateType">
                        <option value="none">No Change Type Selected</option>
                        <option value="add" hidden={this.props.userAccountInfo.accountNbr === "999999"}>
                            Add {this.props.role} to this {this.props.accountType}</option>
                        <option value="remove">Remove {this.props.role} From this {this.props.accountType}</option>
                        <option value="switch" hidden={this.props.accountType === "Household"}>
                            Switch {this.props.role} from this {this.props.accountType} to another
                        </option>
                    </select>
                </div>
                <div className="mt-4 text-left ml-3">
                    <label className={this.userNameClass} htmlFor="userName">
                        {upperCaseRole} Name (username):&nbsp;&nbsp;</label>
                    <input type="text" className="input-sm" id="userName" name="userName"
                        onChange={(val) => this.handleUsernameChange(val.target.value)}
                        value={this.userName}></input> 
                    <div className="text-center">(<b>Note: </b> {upperCaseRole} Name is case sensitive.)</div>
                </div>
                {this.userFound  ?
                    <div className="mt-2">
                        <div className={this.accountNbrClass} >
                            <b>Current {this.props.accountType} Code: </b> &nbsp;  {this.accountNbr}
                        </div>
                        <div className={this.roleClass}>
                            <b>Role:</b> &nbsp; {this.loginInfo.role} &nbsp;&nbsp;
                            <span className="text-green font-weight-bold"> {this.roleMessage} </span>
                        </div>
                        <div className="mt-4"></div>
                    </div>
                
                :
                    null
                }
                {this.state.updateType === "switch" ?
                    <>
                        <div className="mt-4 text-left ml-3 font-weight-bold">
                            <label className={this.newAccountNbrClass} htmlFor="newAccountNbr">
                                New {this.props.accountType} Code:&nbsp;&nbsp;</label>
                            <input type="text" className="input-sm" id="newAccountNbr" name="newAccountNbr"
                                onChange={(val) => this.handleAccountNbrChange(val.target.value)}
                                value={this.newAccountNbr}></input> 
                        
                        </div>
                       <div className="ml-3 text-left"><b>New Class Name: </b>{this.newAccountClassName}</div>
                    </>
                :
                    null
                }
            </span>
                    
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
              <div className={this.messageClass}>
                    {this.message}
              </div>
              <div>
                {this.state.updateStep === "initial"  ?
                    <>
                        <Button variant="primary"  onClick={() => this.processUserInput()}>
                            Submit
                        </Button>
                        <Button className="ml-4" variant="secondary"  onClick={() => this.props.onClose()}>
                            Close
                        </Button>
                    </>
                :
                    null
                }
                {this.state.updateStep === "confirm"  ?
                    <>
                        <Button variant="primary"  onClick={() => this.updateUserAndAccount()}>
                            Confirm
                        </Button>
                        <Button className="ml-4" variant="secondary"  onClick={() => this.startOver()}>
                            Reset/Clear
                        </Button>
                        <Button className="ml-4" variant="secondary"  onClick={() => this.props.onClose()}>
                            Close
                        </Button>
                    </>
                :
                    null
                }
                </div>

        </Modal.Footer>
       
    </Modal>
    
  </>
}

async processUserInput(){
    this.message = "";
    this.userFound = false;
    this.setState({waitState: true})
    if (this.userName && this.userName !== ""){
        await this.getUser();
    }
    if (this.state.updateType === "switch" && this.newAccountNbr && this.newAccountNbr !== ""){
        await this.getAccount();
    }
    this.editInputValues();
  
}

async editInputValues(){
    // research "Unassigned" displayed in account number for student10 when trying to add as teacher to Cheryl4
    this.messageClass = "text-danger font-weight-bold text-left ml-4 w-100"
    let skipEdit = false;
    if (this.props.userAccountInfo.accountOwnerArr.includes("Admin")){
        //  accountOwner is "Admin" only if signed on with a role of "Admin"
        skipEdit = true;
    }
    let newAccountOwnerArr = [];
    this.newAccountClassName = "";
    if (this.newAccountNbr && this.accountFound === true){
        newAccountOwnerArr = this.accountData.accountOwnerArr.map(obj => obj.username);
        this.newAccountClassName = this.accountData.className;
    }
    const loggedInAccountOwners = this.props.userAccountInfo.accountOwnerArr.map(obj => obj.username);
    const errorObj = editManagePlayerInputs(skipEdit, this.props.role, this.userFound, this.userName, 
        this.loginInfo.accountNbr, this.loginInfo.role, this.state.updateType, 
        this.props.userAccountInfo.accountNbr, 
        this.props.accountType, newAccountOwnerArr, this.props.user, this.newAccountNbr, 
        this.accountFound, loggedInAccountOwners, this.props.userRole
    );
    this.updateTypeClass = errorObj.updateTypeClass;
    this.accountNbrClass = errorObj.accountNbrClass;
    this.roleClass = errorObj.roleClass;
    this.accountNbr = errorObj.displayAccountNbr;
    this.newAccountNbrClass = errorObj.newAccountNbrClass;
    this.userNameClass = errorObj.userNameClass;
    this.message = errorObj.message;
    this.newRole = this.loginInfo.role;
    this.roleMessage = "";
    if (errorObj.errorsFound === false){
        if (this.props.role === "teacher" || this.props.role === "parent") {
            if (this.state.updateType === "add" && this.loginInfo.role === "player"){
                this.newRole = this.props.role;
                this.roleMessage = "Note:  role will be changed to " + this.props.role;
            }
            if (this.state.updateType === "remove" ){
                this.newRole =  await this.checkAccountList();
                if (this.newRole === "player"){
                    this.roleMessage = "Note: role will be changed to player."
                };
            }
        }
        this.messageClass="text-green font-weight-bold text-left ml-4 w-100";
        this.setState({updateStep: "confirm"});
    }
    this.setState({waitState: false});
}

async checkAccountList(){
    // if this user is a teacher or parent and they are being removed from an account and it is the only account 
    // they are assigned to, then their role will be changed back to 'player' (it will be changed back
    // to parent or teacher if/when they are assigned to another account as a parent or a teacher). 
 
    const userAccountList = await this.getAccountList(this.userName);
    let role = this.userRole;
    this.userAccountList = userAccountList.filter(elem => elem.accountNbr !== this.props.userAccountInfo.accountNbr);
    if (this.userAccountList.length === 0){
        role = "player";
    }
    return role;
}

startOver(){
    this.message = "";
    this.userFound = false;
    this.setState({updateStep:  "initial"});
}

updateUserAndAccount(){
    this.setState({waitState: true});
    if (this.props.role === "teacher" || this.props.role === "parent"){
        const revisedUserAccount = this.changeAccountData(this.props.userAccountInfo, "userAccount");
        this.props.updateAccount(revisedUserAccount);
        if (this.state.updateType === 'switch'){
            const revisedNewAccount = this.changeAccountData(this.accountData, "newAccount");
            this.props.updateAccount(revisedNewAccount);
        }
    }
    this.changeUserData();
    this.setState({waitState: false});
}

changeAccountData(accountData, accountType){
    const currDateTime = getCurrentDateTime(); 
    if (this.state.updateType === "add" ||
       (this.state.updateType === "switch" && accountType === "newAccount")){
        const newOwnerObj = {username: this.userName, updateDate: currDateTime.date};
        accountData.accountOwnerArr.push(newOwnerObj);
    }
    if (this.state.updateType === "remove" || 
       (this.state.updateType === "switch" && accountType === "userAccount")){
        const ownerIndx = accountData.accountOwnerArr.findIndex(elem => elem.username === this.userName);
        if (ownerIndx !== -1){
            accountData.accountOwnerArr.splice(ownerIndx, 1);
        }
    }
    return accountData;
}
 
changeUserData(){
    let userObj = {};
    switch (this.state.updateType){
        case "add":
            userObj = {username: this.userName, accountNbr: this.props.userAccountInfo.accountNbr, role: this.newRole};
            break;
        case "remove":
            if (this.newRole === "player"){
                userObj = {username: this.userName, accountNbr: "Individual", role: this.newRole};
            }else{
                // get account nbr that is the most recent update for this user
                let updateAccountNbr = "";
                let mostRecentUpdateDate = "0000/00/00";
                for (let i=0; i<this.userAccountList.length; i++){
                    const dateUpdated = 
                        this.userAccountList[i].accountOwnerArr.find(elem => elem.username === this.userName).dateUpdated;
                    if (dateUpdated && dateUpdated > mostRecentUpdateDate){
                        mostRecentUpdateDate = dateUpdated
                        updateAccountNbr = this.userAccountList[i].accountNbr;
                    }
                }
                userObj = {username: this.userName, accountNbr: updateAccountNbr, role: this.newRole};
            }
            break;
        case "switch":
            userObj = {username: this.userName, accountNbr: this.newAccountNbr, role: this.newRole};
            break;
        default:
            break;
    }
    this.props.updateUser(userObj);
}

async getAccountList(userName) {
    // retrieve all accounts where userName is an accountOwner
    const funcName = "loadAccountList";
    const urlParm = "?userName=" + userName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, { method: 'GET', headers: this.state.headers });

        if (response.ok) {
            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;

            if (statusCode === 200) {
                return output.body;

            } else if (statusCode === 250) {
                return [];

            } else {
                const errorObj = {
                    function: funcName,
                    subProcess: this.state.subProcess,
                    status: statusCode,
                    message: output.body.message
                };
                this.props.processError(errorObj);
            }
        }
    } catch (error) {
        const errorObj = {
            function: funcName,
            subProcess: this.state.subProcess,
            status: 500,
            message: error.message
        };
        this.props.processError(errorObj);
    }
}

async getUser() {
    const funcName = "loadUser";
    const urlParm = "?username=" + this.userName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, { method: 'GET', headers: this.state.headers });

        if (response.ok) {
            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;

            if (statusCode === 200) {
                this.loginInfo = output.body;
                this.userFound = true;
            } else if (statusCode === 250) {
                this.loginInfo = {accountNbr: "", role: ""};
                this.userFound = false;
            } else {
                const parmObj = { rqstType: this.rqstType, username: this.username };
                const errorObj = {
                    function: funcName,
                    subProcess: this.subProcess,
                    status: statusCode,
                    message: output.body.message,
                    errorObject: parmObj
                };
                this.props.processError(errorObj);
            }
        }
    } catch (error) {
        const errorObj = {
            function: funcName,
            subProcess: this.subProcess,
            status: 500,
            message: error.message,
            errorObject: error
        };
        this.props.processError(errorObj);
    }
}
  
async getAccount() {
    const funcName = "loadAccount";
    const urlParm = "?accountNbr=" + this.newAccountNbr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, { method: 'GET', headers: this.state.headers });

        if (response.ok) {
            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200) {
                this.accountFound = true;
                this.accountData = output.body;
            } else if (statusCode === 250) {
                this.accountFound = false;
            } else {
                const errorObj = {
                    function: funcName,
                    subProcess: this.state.subProcess,
                    status: statusCode,
                    message: output.body.message
                };
                this.props.processError(errorObj);
            }
        }
    } catch (error) {
        const errorObj = {
            function: funcName,
            subProcess: this.state.subProcess,
            status: 500,
            message: error.message
        };
        this.props.processError(errorObj);
    }
}


}
export default ManagePlayersForAccount;